module.exports = __webpack_public_path__ + "img/02.1ad7d3f8.jpg";